/* eslint-disable import/prefer-default-export */
import { formValueSelector } from 'redux-form';
import getTravelerFormSectionName from './travelerFormName';
import { FIRST_NAME } from './constants';
export const getSelected = form => (state, id) => formValueSelector(form)(state, getTravelerFormSectionName(id, FIRST_NAME)) || null;
//# sourceMappingURL=firstName.js.map